import RequestAjax from './httpRequest';
/**
 * 统计模块
 */
class sendVplayer {
    /**
     * 初始化定义统计需要发送的参数
     */
    constructor() {
        this.vStaUrl = ''; // 发送统计的地址
        this.sendVplayer = {
            type: 'CDN', // 下载类型 CDN P2P
            status: 'success', // 下载状态 failed success
            dl_bytes: 0, // 下载字节数
            group: 'ifengH5', // 分组
            block_id: 0, // 块号
            url: '', // 请求的mp4地址
            total_block: 0, // 总块号
        };
        this.httpRequest = new RequestAjax();
    }
    /**
     *
     * @param {Object} params 统计参数
     * @param {String} vStaUrl 发送统计的地址
     */
    init(params, vStaUrl) {
        this.vStaUrl = vStaUrl;
        this.updateParams(params);
    }
    /**
     *
     * @param {Object} params 更新统计参数
     */
    updateParams(params) {
        for (let i in params) {
            this.sendVplayer[i] = params[i];
        }
    }
    /**
     *
     * @param {Object} params 发送的统计的参数
     */
    sendCdn(params) {
        this.sendVplayer.type = 'CDN';
        this.updateParams(params);
        if (this.vStaUrl) {
            this.httpRequest.sendRequestJsonp(this.vStaUrl, this.sendVplayer);
        }
    }
    /**
     *
     * @param {Object} params 发送统计的参数
     */
    sendP2p(params) {
        this.sendVplayer.type = 'P2P';
        this.updateParams(params);
        if (this.vStaUrl) {
            this.httpRequest.sendRequestJsonp(this.vStaUrl, this.sendVplayer);
        }
    }
}

export default sendVplayer;



// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/modules/staP2P.js